import React from 'react'

export const Footer = () => {

  let fcss = {
    color: '#000',
    margin: '0',
    padding: '0',
    textAlign: 'center',
    marginTop: '19rem',
    marginBottom: 0,
    borderTop: '1px solid #e9e9e9'
  }
  return (
    <>
      <div className='footers'>
        <table>
          <tbody>
            <tr>
              <th>선물추천</th>
              <td><a href="#">온라인 서비스</a></td>
            </tr>
            <tr>
              <th>고객센터</th>
              <td><a href="#">공지사항</a></td>
              <td><a href="#">주문 배송 조회</a></td>
              <td><a href="#">적립금 현황</a></td>
              <td><a href="#">고객서비스</a></td>
              <td><a href="#">자주 묻는 질문</a></td>
              <td><a href="#">1:1 문의하기</a></td>
              <td><a href="#">기업 구매 문의</a></td>
            </tr>
            <tr>
              <th>소셜</th>
              <td><a href="#">instagram</a></td>
              <td><a href="#">KaKaotalk</a></td>
              <td><a href="#">Weibo</a></td>
              <td><a href="#">Facebook</a></td>
            </tr>
          </tbody>
        </table>

      </div>
      <p className='end' style={fcss}>Copyright ⓒ ALL RIGHT RESERVED.</p>
    </>
  )
}

export default Footer;
